/**
 * Check if an entity should be ignored
 */
export function shouldIgnoreEntity(data) {
    return data?.['x-internal'] === true || data?.['x-gitbook-ignore'] === true;
}
